import request from '@/utils/request'

// 顾客需求列表
export function customer_needs_index (data) {
    return request({
        url: 'system/needs_index',
        method: 'get',
        params: data
    })
}
// 修改需求
export function set_customer_demand (data) {
    return request({
        url: 'customer/set_demand',
        method: 'post',
        data
    })
}
//顾客行业列表
export function customer_industry_list (data) {
    return request({
        url: 'system/industry_list',
        method: 'get',
        params: data
    })
}
// 修改行业
export function set_customer_industry (data) {
    return request({
        url: 'customer/set_industry',
        method: 'post',
        data
    })
}
//跟进顾客的员工
export function customer_department_member (data) {
    return request({
        url: 'company/department_member_list',
        method: 'get',
        params: data
    })
}
// 修改跟进顾客的员工
export function set_customer_staff (data) {
    return request({
        url: 'customer/set_staff',
        method: 'post',
        data
    })
}


// 获取所有客户列表
export function get_customer_list(data){
    return request({
        url: 'customer/customer_list',
        method: 'get',
        params:data
    })

}

// 跟进记录
export function follow_record_list(data){
    return request({
        url: 'customer/follow_record',
        method: 'get',
        params:data
    })
}

//编辑跟进记录
export function follow_edit(data){
    return request({
        url: 'customer/edit_follow',
        method: 'post',
        data
    })
}
//编辑跟进记录
export function follow_del(data){
    return request({
        url: 'customer/del_follow',
        method: 'post',
        data
    })
}



// 删除图片
export function del_img(data){
    return request({
        url: 'customer/del_img',
        method: 'post',
        data
    })
}

// 修改用户资料
export function save_customer_info(data){
    return request({
        url: 'customer/set_customer_info',
        method: 'post',
        data
    })
}

// 修改用户画像
export function set_customer_portrait(data){
    return request({
        url: 'customer/set_customer_portrait',
        method: 'post',
        data
    })
}
// 修改用户画像
export function query_customer_qrcode(data){
    return request({
        url: 'customer/query_customer_qrcode',
        method: 'post',
        data
    })
}
// 修改用户画像
export function set_customer_qrcode(data){
    return request({
        url: 'customer/set_customer_qrcode',
        method: 'post',
        data
    })
}

// 获取成交类型
export function get_transaction(data){
    return request({
        url: 'customer/transaction_list',
        method: 'get',
        params:data
    })
}


// 客户类型
export function customer_type(data) {
    return request({
        url: 'system/customer_indexs',
        method: 'get',
        params:data
    })
}
